export default __webpack_public_path__ + "static/media/img-0271-saudi-arabia-premium-face.ded98783.png";